import React, { useContext } from 'react';
import { ThemeContext } from '../../App';
import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';

const Toggle = () => {
  const { theme, toggleTheme } = useContext(ThemeContext);
  
  return (
    <motion.button
      className="darkmodeswitch"
      onClick={toggleTheme}
      title={theme === 'light' ? 'Switch to Dark Mode' : 'Switch to Light Mode'}
      whileHover={{ scale: 1.05, rotate: 10 }}
      whileTap={{ scale: 0.95, rotate: -10 }}
      animate={{ rotate: theme === 'light' ? 0 : 180 }}
      transition={{ 
        type: "spring",
        stiffness: 220,
        damping: 18
      }}
    >
      <Icon
        icon={`${theme === 'light' ? 'bi:moon-fill' : 'bi:sun-fill'}`}
        height={28}
        width={28}
      />
    </motion.button>
  );
};

export default Toggle;
